import AddUserModalSummary from './component'

export default AddUserModalSummary



// WEBPACK FOOTER //
// ./src/components/AddUserModalSummary/index.js